import _ from 'lodash'

/**
 * Like debounce but memoized to avoid repetitive calls.
 */
const memoizedDebounce = (func, wait = 0, options = {}) => {
  const mem = _.memoize(function () {
    return _.debounce(func, wait, options)
  }, options.resolver)
  return function () {
    mem.apply(this, arguments).apply(this, arguments)
  }
}

export default memoizedDebounce
